import { Image } from '@/components/Image';
import { CardLink } from '@/types/card';
import { Link } from '@/types/link';
import { cn } from '@/utils/cn';
import { getIconForLink } from '@/utils/getIconForLink';
import { memo } from 'react';

export const LinkIcon = memo(
  ({
    link,
    iconStyle,
    emojiStyle,
    className,
  }: {
    link: CardLink | Link;
    iconStyle?: string;
    emojiStyle?: string;
    className?: string;
  }) => {
    const iconSrc = getIconForLink(link.icon);
    const type = link.type;

    return (
      <div
        className={cn(
          'flex aspect-square size-20 items-center justify-center overflow-hidden',
          className,
        )}
      >
        {type === 'custom_link' ? (
          <div
            className={cn(
              'flex items-center justify-center rounded-[12px] bg-gray-100 font-emoji text-3xl leading-none',
              emojiStyle,
            )}
          >
            {link.icon}
          </div>
        ) : (
          <Image
            src={iconSrc}
            alt={link.title || 'Link Icon'}
            className={cn('rounded-xl object-cover', iconStyle)}
          />
        )}
      </div>
    );
  },
);
